import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "filter-black",
  "use": "filter-black-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"filter-black\"><path d=\"M13.352 0H.646A.59.59 0 00.06.387C-.053.66-.006.9.2 1.082l4.895 4.894V10.8a.61.61 0 00.188.447l2.542 2.54a.59.59 0 00.447.189.69.69 0 00.248-.05.59.59 0 00.387-.585V5.976L13.8 1.082a.57.57 0 00.138-.695.59.59 0 00-.586-.387z\" fill=\"#333\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol